import { call, put, select } from "redux-saga/effects";
import { actions as formActions } from "@/reducers/form-reducer";
import LocalStorageLib from '@gcloud-npm/utils.secure.local-storage';
import { redeemCampaign as redeemCampaignAda } from '@/component/redeem-campaign';
import sendRetargeting from '@/component/send-retargeting';
import { getClientsIds } from '@gcloud-npm/utils.c2c';
import setCookie from "@gcloud-npm/utils.common.set-cookie";
import getUUID from "@gcloud-npm/utils.monitoring.get-uuid";


const contextStore = (state) => state.main.context;

export function* sendDraw({campaign}) {
  try {
    const context = yield select(contextStore);
    const requestId = getUUID('VT', '', false);
    const retargeting = yield call(sendRetargeting, {
      data: {
        campaign: {
          id: campaign.replaceAll("_", "-"),
        },
        products: [],
        context: {
          url: btoa(context?.contextURL || window.location.href),
          ga: getClientsIds(context),
        },
        contactInfo: {
        },
      },
      context,
      logged: true,
      requestId: requestId
    });

    const redeemCampaign = {
          campaignId: campaign,
          transactionId: requestId,
        };
    yield call(redeemCampaignAda, {
      data: redeemCampaign,
      context,
    });

    const localStorageLib = new LocalStorageLib();
    const persistedInfo = localStorageLib.getItem('ts');
    let campaignsRedeemed = persistedInfo?.customer?.campaigns?.redeemed;
    if (campaignsRedeemed && Array.isArray(campaignsRedeemed) && campaignsRedeemed.length > 0) {
      campaignsRedeemed.push({
        campaignId: campaign,
      });
    } else {
      campaignsRedeemed = [
        {
          campaignId: campaign,
        },
      ];
    }
    const updatedInfo = {
      ...persistedInfo,
      customer: {
        ...persistedInfo.customer,
        campaigns: {
          ...persistedInfo.customer?.campaigns,
          redeemed: campaignsRedeemed,
        },
      },
    };
    localStorageLib.setItem('ts', updatedInfo);
    setCookie(`${persistedInfo.userIdPartyHash}-${campaign}`, true, "1d");
    
    yield put(formActions.sendDrawSuccess(campaign));
  } catch (error) {
    try {
      const localStorageLib = new LocalStorageLib();
      const persistedInfo = localStorageLib.getItem('ts');
      const campaignsRedeemed = persistedInfo?.customer?.campaigns?.redeemed;

      if (campaignsRedeemed && Array.isArray(campaignsRedeemed)) {
        const updatedRedeemed = campaignsRedeemed.filter(
          (c) => c.campaignId !== campaign
        );
        const updatedInfo = {
          ...persistedInfo,
          customer: {
            ...persistedInfo.customer,
            campaigns: {
              ...persistedInfo.customer?.campaigns,
              redeemed: updatedRedeemed,
            },
          },
        };
        localStorageLib.setItem('ts', updatedInfo);
      }
    } catch (e) {
    }
    
    yield put(formActions.sendDrawFailure(campaign));
  }
}
